import { createModelSegment } from 'client/data/luckdragon/segment';

export const ExperimentsModel = createModelSegment('experiments', []);
